// extracted by mini-css-extract-plugin
module.exports = {"heading":"UsersListV2_heading__3i4cF","sortIcon":"UsersListV2_sortIcon__pWTNe","actionButton":"UsersListV2_actionButton__2laqB","deleteButton":"UsersListV2_deleteButton__3nwu2"};